<template>
  <div class="has-float-label" :class="{ 'form-group': margin }">
    <b-input
      class="form-control"
      :id="inputId"
      :size="size"
      placeholder=" "
      :type="inputType"
      :name="name"
      :class="cssClass"
      :value="value"
      @input="(e) => $emit('input', e)"
    />
    <label :for="inputId">{{ lableText }}</label>
  </div>
</template>
<script>
export default {
  name: "input",
  data() {
    return {
      context: null,
    };
  },
  props: {
    inputType: {
      type: String,
      required: false,
      default: "text",
    },
    name: {
      type: String,
      required: false,
      default: "textbox",
    },
    cssClass: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    lableText: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
      default:""
    },
    inputId: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      required: false,
      default: "lg",
    },
    margin: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/bootstrap-float-label.css";

.form-control {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: "Lato";
  height: 39px !important;
  border: 1px solid #dee2e6;
}

.form-control:focus {
  border-color: #dee2e6;
}

.form-control-lg {
  font-size: 130%;
}

.a {
  display: block;
  padding: 10px;
  position: absolute;
  z-index: -1;
  top: 1rem;
  left: 100%;
  margin-left: -62px;
  transition: all 0.2s;
}

a:hover {
  margin-left: 0;
}
</style>